module.exports = __webpack_public_path__ + "img/ico_export.0edcc986.svg";